/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-19 10:31:23
 * @LastEditTime: 2019-08-16 17:55:35
 * @LastEditors: Please set LastEditors
 */
// import {api} from '../../utils/api'

export default {
  state: {
    uid: 0,
    userInfo: {},
    aesid: 0,
    session: '',
    guid: '',
    version: ''
  },
  getters: {
    uid: state => {
      return state.uid// 用户的encrypt
    },
    guid: state => {
      return state.guid
    },
    version: state => {
      return state.version
    },
    session: state => {
      return state.session
    },
    userInfo: state => {
      return state.userInfo
    }
  },
  mutations: {
    loginIn (state, uid) {
      state.uid = uid
    },
    setUserInfo (state, info, flg) {
      state.userInfo = info
    },
    setUserVersion (state, version, flg) {
      state.version = version
    },
    setBaseInfo (state, info) {
      state.uid = info.uid
      state.version = info.version
      state.session = info.session
      state.guid = info.guid
    }
  },
  actions: {
    /* GETUSERINFO ({commit, state}) {
      // return api(state.uid,{ srv: "user_user",cmd: "get_user_info"},{}).then(res=>{
      return api('user/getUserInfo', {}, state.userId, state.session).then(res => {
        res = res
        console.log(res)
        console.log('user/getUserInfo')
        if (res.code != 200) {
          if (res.code == 999) {
            location.href = '../../../../testLogin/build/index.html'
          } else {
            return res.msg
          }
        } else {
          // 待定  --wwj
          commit('setUserInfo', res.body)
          Promise.resolve()
        }
      })
    } */
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js